export const CS_CONTENTS_CONTINUE_ATTEMPTED = 'CS_CONTENTS_CONTINUE_ATTEMPTED';

export const csContentsContinueAttempted = (payload: { unsetKey: string }) => ({
  type: CS_CONTENTS_CONTINUE_ATTEMPTED,
  payload,
});
